import {EElementType} from "../utils/EElementType";
import ModelsRegExp from "../../services/ModelsRegExp";

export abstract class AElement {

    private _type: EElementType;
    private _serialNumber: string;
    private _isScanned: boolean;

    private _serialNumberRegExp: RegExp;

    protected constructor(type: EElementType, serialNumber: string, isScanned?: boolean, serialNumberRegExp?: RegExp) {
        this._type = type;
        this._serialNumber = serialNumber;
        this._isScanned = isScanned !== undefined ? isScanned : false;
        this._serialNumberRegExp = serialNumberRegExp !== undefined ? serialNumberRegExp : ModelsRegExp.elementUnknown;
    }

    get type(): EElementType {
        return this._type;
    }

    set type(value: EElementType) {
        this._type = value;
    }

    get serialNumber(): string {
        return this._serialNumber;
    }

    set serialNumber(value: string) {
        this._serialNumber = value;
    }

    get isScanned(): boolean {
        return this._isScanned;
    }

    set isScanned(value: boolean) {
        this._isScanned = value;
    }

    protected get serialNumberRegExp(): RegExp {
        return this._serialNumberRegExp;
    }

    protected set serialNumberRegExp(value: RegExp) {
        this._serialNumberRegExp = value;
    }

    public isSerialNumberRightFormat(): boolean {
        return !!this.serialNumberRegExp.exec(this.serialNumber);
    }

    public isCorrect(): boolean {
        return (
            this.isSerialNumberRightFormat()
        );
    }

}

